import React from 'react'
import classes from './DeployButton.module.scss'
import { WebhookSection, TriggersSection, useGuideUrl, useWebhookSubscriptions } from '@/features/zendesk-app'
import Typography from '@/components/ui/Typography'
import NoAuthAlert from '@/components/DeployButton/NoAuthAlert'
import { useGetRoute } from '@/lib/react-query'
import Button from '@/components/ui/Buttons/Button'

export type ZendeskAppDeployInstructionsProps = {
  projectId: number
  routeId: number
}

const ZendeskAppDeployInstructions = ({ projectId, routeId }: ZendeskAppDeployInstructionsProps) => {
  const {
    data: { route },
  } = useGetRoute(projectId, routeId)
  const guideUrl = useGuideUrl()
  const webhookSubscriptions = useWebhookSubscriptions()
  const hasTrigger = webhookSubscriptions.length === 0 || webhookSubscriptions.includes('conditional_ticket_events')

  const openDeployArticle = () => window.open(guideUrl, '_blank')

  return (
    <div className={classes.zendeskAppRoot}>
      {!route.authEnabled && <NoAuthAlert projectId={projectId} routeId={routeId} />}
      <Typography>1. Ensure the webhook is active and error-free.</Typography>
      <WebhookSection projectId={projectId} routeId={routeId} />
      {hasTrigger && (
        <>
          <Typography>
            2. Create or modify an existing trigger to align with the expected conditions and payload structure
          </Typography>
          <TriggersSection projectId={projectId} routeId={routeId} />
        </>
      )}

      <Typography>
        {hasTrigger ? '3' : '2'}. It always makes sense that you test the configuration with a ticket that meets all the
        trigger conditions. Please find some further information about knots Studio and what you can do with it here
      </Typography>
      <div>
        <Button variant={'outlined'} color={'neutral'} onClick={openDeployArticle} onAuxClick={openDeployArticle}>
          Knots Studio Guide
        </Button>
      </div>
    </div>
  )
}

export default ZendeskAppDeployInstructions
